import { render } from "./DevicesPage.vue?vue&type=template&id=1dc12e70"
import script from "./DevicesPage.vue?vue&type=script&lang=js"
export * from "./DevicesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__